<template>
  <div class="dashboard-container">
    <SimulationView/>
    <ControlPanel/>
  </div>
</template>

<script>
import ControlPanel from './ControlPanel.vue';
import SimulationView from './SimulationView.vue';

export default {
  name: 'Dashboard',
  components: {
    ControlPanel,
    SimulationView
  }
}
</script>

<style scoped>
.dashboard-container {
  background-image: url("../../public/vr.jpg");
  background-position: center;
}
</style>